var map = {
	"./State=State3.svg": "eab6",
	"./all-fill.svg": "1fe4",
	"./all.svg": "34ce",
	"./archived-fill.svg": "68dd",
	"./archived.svg": "777b",
	"./cancel.svg": "84d0",
	"./download.svg": "def1",
	"./edit.svg": "3b70",
	"./fill_star_gold.svg": "4fc4",
	"./save.svg": "0df62",
	"./sstarred.svg": "c37a",
	"./starred-fill.svg": "0656",
	"./starred.svg": "8f53",
	"./switch.svg": "43e5",
	"./warchived.svg": "8e06"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "727d";